var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2739_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.21065 9.6875C6.15485 9.4712 6.04211 9.27381 5.88416 9.11586C5.72621 8.95791 5.52882 8.84517 5.31252 8.78937L1.47815 7.80062C1.41273 7.78206 1.35515 7.74266 1.31416 7.6884C1.27316 7.63415 1.25098 7.568 1.25098 7.5C1.25098 7.432 1.27316 7.36585 1.31416 7.3116C1.35515 7.25734 1.41273 7.21794 1.47815 7.19937L5.31252 6.21C5.52874 6.15425 5.72608 6.04161 5.88402 5.88377C6.04197 5.72594 6.15475 5.52868 6.21065 5.3125L7.1994 1.47812C7.21778 1.41245 7.25714 1.35459 7.31147 1.31337C7.36581 1.27215 7.43214 1.24984 7.50034 1.24984C7.56853 1.24984 7.63486 1.27215 7.6892 1.31337C7.74353 1.35459 7.78289 1.41245 7.80127 1.47812L8.7894 5.3125C8.8452 5.52879 8.95794 5.72618 9.11589 5.88413C9.27384 6.04209 9.47123 6.15483 9.68752 6.21062L13.5219 7.19875C13.5878 7.21694 13.646 7.25625 13.6874 7.31067C13.7289 7.36509 13.7513 7.4316 13.7513 7.5C13.7513 7.5684 13.7289 7.63491 13.6874 7.68933C13.646 7.74374 13.5878 7.78306 13.5219 7.80125L9.68752 8.78937C9.47123 8.84517 9.27384 8.95791 9.11589 9.11586C8.95794 9.27381 8.8452 9.4712 8.7894 9.6875L7.80065 13.5219C7.78227 13.5875 7.74291 13.6454 7.68857 13.6866C7.63424 13.7278 7.56791 13.7502 7.49971 13.7502C7.43151 13.7502 7.36518 13.7278 7.31085 13.6866C7.25651 13.6454 7.21715 13.5875 7.19877 13.5219L6.21065 9.6875Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.875V4.375",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.125H11.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 10.5L2.25 12.75",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 11.25H1",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2739_1666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChat);
export default __webpack_public_path__ + "static/media/ai-chat.2d27f7ee66a5ed58f2ec838f50d7eada.svg";
export { ForwardRef as ReactComponent };